import { mdxDecorators } from '@playbooks/decorators';

const blogMdxComponents = mdxDecorators({
	h1: props => <h1 {...props} />,
	h2: props => <h2 {...props} />,
	h3: props => <h3 {...props} />,
	h4: props => <h4 {...props} />,
	h5: props => <h5 {...props} />,
	h6: props => <h6 {...props} />,
});

export { blogMdxComponents };
